import { useRecoilState } from 'recoil'
import { useEffect, useState } from 'react'
import { EntityWithId, IUseEntityProps } from './useEntity.types'
import useHttpLoader from '../../shared/hooks/useHttpLoader.ts'
import { HTTPResponse } from '@/services/http/http.types.ts'

const useEntity = <T extends EntityWithId>(props: IUseEntityProps<T>) => {
  const [state, setState] = useRecoilState(props.atom)
  const [entity, setEntity] = useState<T>(
    props.forceLoad === true ? undefined : state.items.find((o) => o.id === props.entityId)
  )
  const { wait, loading } = useHttpLoader(!Boolean(entity))

  useEffect(() => {
    if (props.forceLoad) return

    const item = state.items.find((it) => it.id === props.entityId)
    if (item) setEntity(item)
  }, [state.items, props.entityId])

  useEffect(() => {
    if (entity || !props.entityId) return
    if (state.items.some((it) => it.id === props.entityId) && !props.forceLoad) return

    wait(props.itemFetcher(props.entityId), (resp: HTTPResponse<T>) => {
      if (resp.status === 'success') {
        if (!state.items.some((it) => it.id === resp.body.id)) {
          setState((prev) => ({ ...prev, items: [...prev.items, resp.body] }))
        }
        setEntity(resp.body)
      }
    })
  }, [props.entityId])

  return { entity, loading, setEntity }
}

export default useEntity
